import { apiClient, apiClientPlatform, apiClientTodoTd, SocketEcho } from "../services/config";
import Cookies from "js-cookie";

export const appEnv = process.env.REACT_APP_APP_ENV || process.env.NODE_ENV;
export const cookieSessionName =
	appEnv === "development"
		? "dev_td-token"
		: appEnv === "staging"
			? "staging_td-token"
			: "td-token";

export const getAuthToken = () => Cookies.get(cookieSessionName);

export const setAuthToken = (token) => Cookies.set(cookieSessionName, token);

/**
 * Update auth token
 * @param {*} sessionToken
 */
export const updateAuthToken = (sessionToken) => {
	apiClient.defaults.headers.common.Authorization = `Bearer ${sessionToken}`;
	apiClientTodoTd.defaults.headers.common.Authorization = `Bearer ${sessionToken}`;
	apiClientPlatform.defaults.headers.common.Authorization = `Bearer ${sessionToken}`;
	SocketEcho.options.auth.headers.Authorization = `Bearer ${sessionToken}`;
};

/**
 * Reorder items
 * @param {*} list
 * @param {*} startIndex
 * @param {*} endIndex
 * @returns
 */
export const reorderItems = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);

	const newItems = result.map((item, i) => {
		item.index = i + 1;
		return item;
	});

	return newItems;
};

export const ARRAY_STATUS_ICON = [
	{
		icon: "uncompleted",
		color: "#1EA2CC",
	},
	{
		icon: "completed",
		color: "#1FC810",
	},
	{
		icon: "unrelated",
		color: "#C40BE2",
	},
	{
		icon: "stalled",
		color: "#CFCFD4",
	},
	{
		icon: "planned",
		color: "#234EE9",
	},
	{
		icon: "processing",
		color: "#FFCD1B",
	},
	{
		icon: "message",
		color: "#FF0CBB",
	},
	{
		icon: "eight_point_star",
		color: "#2FDDA9",
	},
	{
		icon: "danger",
		color: "#EE2424",
	},
	{
		icon: "like",
		color: "#6DDE14",
	},
	{
		icon: "four_point_star",
		color: "#FF8024",
	},
	{
		icon: "eye",
		color: "#6583F0",
	},
	{
		icon: "notcompleted",
		color: "#EE2424",
	},
];

export function animationClassHandler(state, enterClass, exitClass) {
	if (state === "entering") return enterClass;

	if (state === "exiting") return exitClass;

	return "";
}

export const redirectToLogin = () => {
	const currentLocation = window.location.href;
	window.location = `${process.env.REACT_APP_HOST_PLATFORM}/login?next=${btoa(currentLocation)}`;
};

export const filterByPartialTerms = (item, searchQuery) => {
	if (!searchQuery || searchQuery.trim() === "") {
		return true;
	}

	const searchTerms = searchQuery.toLowerCase().trim().split(/\s+/);
	const itemText = item.toLowerCase();

	return searchTerms.every((term) => itemText.includes(term));
};

export const infiniteScrollBottomHandler = (e, callBack) => {
	const target = e.target;
	const isBottom = target.scrollHeight === Math.ceil(target.scrollTop + target.clientHeight);

	if (isBottom) {
		callBack();
	}
};

/*/!**
 * preventDragXAxis
 * @param {*} provided
 * @param {*} snapshot
 * @returns
 *!/
function preventDragYAxis(provided, snapshot){

  // Restrict dragging to vertical axis
  let transform = provided.draggableProps.style.transform;

  if (snapshot.isDragging && transform) {
    transform = transform.replace(/\(.+\,/, "(0,");
  }

  return {
    ...provided.draggableProps.style,
    transform,
  };
}*/
